import styles from "../../styles/add.module.scss";

import { Icon } from "../../shared/components/core/Icon";

export const Add = ({ text, onClick, className = "", style = {} }) => {
  return (
    <div
      className={`${styles.addContainer} ${className}`}
      onClick={onClick}
      style={style}
    >
      <Icon name="plus" size="1x" />
      <p className={styles.text}>{text}</p>
    </div>
  );
};
